import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type InitialState = {
  value: MenuData;
};

type MenuData = {
  menuText: string | any;
};

const initialState = {
  value: {
    menuText: ''
  } as MenuData
} as InitialState;

export const menuText = createSlice({
  name: 'menuText',
  initialState,
  reducers: {
    defaultMenu: () => {
      return initialState;
    },
    setMenuSlice: (state, action: PayloadAction<string>) => {
      return {
        value: {
          menuText: action.payload
        }
      };
    }
  }
});

export const { defaultMenu, setMenuSlice } = menuText.actions;
export default menuText.reducer;
